import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetLicensingActionStatusesAsync,
  GetLicensingActionTypesAsync,
  ILicensingActionGridFilterValueList,
} from "../../api/ILicensingAction";
import { RootState } from "../store";

export interface ILicensingActionGridState {
  fetchStatus: string;
  licensingActionTypes?: ILicensingActionGridFilterValueList;
  licensingActionStatuses?: ILicensingActionGridFilterValueList;
}

const initialState: ILicensingActionGridState = {
  fetchStatus: "Loading...",
  licensingActionTypes: undefined,
  licensingActionStatuses: undefined,
};

export const loadLicensingActionOptionsAsync = createAsyncThunk(
  "licensingAction/loadOptions",
  async () => {
    const recordTypes = await GetLicensingActionTypesAsync();
    const recordStatuses = await GetLicensingActionStatusesAsync();
    // The value we return becomes the `fulfilled` action payload
    return {
      licensingActionTypes: recordTypes,
      licensingActionStatuses: recordStatuses,
    };
  }
);

export const licensingActionOptionsSlice = createSlice({
  name: "licensingActionOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadLicensingActionOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadLicensingActionOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.licensingActionTypes = action.payload.licensingActionTypes;
        state.licensingActionStatuses = action.payload.licensingActionStatuses;
      });
  },
});

export const selectLicensingActionOptions = (state: RootState) =>
  state.licensingActionOptions;

export default licensingActionOptionsSlice.reducer;
